export default {
    area: 'Areal',
    name: 'Navn',
    first_name: 'Fornavn',
    last_name: 'Efternavn',
    english_name: 'Engelsk navn',
    local_name: 'Lokalt navn',
    email: 'E-mail',
    phone: 'Telefonnummer',
    key: 'Nøgle',
    prefix: 'Præfiks',
    information: 'Information',
    description: 'Beskrivelse',
    description_en: 'ENG beskrivelse',
    description_da: 'DA beskrivelse',
    role_description_en: 'En rolle beskrivelse',
    role_description_da: 'DA rolle beskrivelse',
    file: 'Fil',
    category: 'Kategori',
    file_en: 'ENG fil',
    file_da: 'DA fil',
    image: 'Billede',
    title: 'Titel',
    title_en: 'ENG titel',
    title_da: 'DA titel',
    project: 'Projekt',
    projects: 'Projekter',
    project_name: 'Projekt navn',
    project_owner: 'Projekt ejer',
    project_description: 'Projekt beskrivelse',
    company_name: 'Firmanavn',
    address: 'Adresse',
    street: 'Gade',
    city: 'By',
    zipcode: 'Postnummer',
    floor: 'Etage',
    door: 'Dør',
    country: 'Land',
    privacy_url: 'Privatlivets URL',
    website_url: 'Hjemmeside URL',
    vat_number: 'Momsnummer',
    app_store_url: 'App store URL',
    google_play_url: 'Google play URL',
    rooms_count: 'Værelser tæller',
    title_number: 'Titel nummer',
    variant_type: 'Variant type',
    unit_group: 'Enhedsgruppe',
    type: 'Type',
    communication_channel: 'Kommunikationskanal',
    event_start_time: 'Begivenhed starttidspunkt',
    event_end_time: 'Begivenhedens sluttid',
    contract_date: 'Kontrakt dato',
    role: 'Rolle',
    ticket_title: 'Billet titel',
    ticket_message: 'Billet besked',
    ticket_project: 'Billetprojekt',
    ticket_property: 'Billet ejendom',
    ticket_receiver: 'Billetreporter',
    ticket_type: 'Billettype',
    ticket_category: 'Billetkategori',
    ticket_assignee: 'Billetmodtager',
    ticket_priority: 'Billetprioritet',
    ticket_status: 'Billetstatus',
    role_assignee: 'Rollemodtager',
    price: 'Pris',
    min_bookable_blocks: 'Min. Reserverbare blokke',
    max_bookable_blocks: 'Maks. Reserverbare blokke',
    max_bookings_per_block: 'Maks. Bookinger pr. Blok',
    price_per_block: 'Pris pr. Blok',
    move_in_date: 'Flyt-in dato',
    internal: 'Indre',
    rent: 'Leje',
    deposit: 'Depositum',
    water: 'Vand',
    heating: 'Opvarmning',
    power: 'Strøm',
    internet: 'Internet',
    prepaid_rent: 'Forudbetalt leje',
    total_paid: 'I alt betalt',
    future_rent: 'Fremtidig leje',
    private: 'Privat',
    old_password: 'Gammelt kodeord',
    new_password: 'Nyt kodeord',
    password_confirm: 'Bekræft kodeord',
    gender: 'Køn',
    age: 'Alder',
    birthday: 'Fødselsdag',
    cpr: 'CPR nummer',
    number: 'Nummer',
    interested_from: 'Interesseret fra',
    corporation: 'Virksomhed',
    external_id: 'Eksternt id',
    motivation: 'Motivering',
    about_me: 'Om mig',
    unit_type: 'Enhedstype',
    rooms: 'Værelser',
};
